import Grid from '@mui/material/Grid';
import { ReactNode } from 'react';

interface ReportActionsGridItemProps {
  children: ReactNode;
}

const ReportActionsGridItem = ({ children }: ReportActionsGridItemProps) => (
  <Grid item xs={12} md="auto" lg="auto" xl="auto" sx={{ ml: { md: 'auto' } }}>
    {children}
  </Grid>
);

export default ReportActionsGridItem;
